import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var FilterOptionsReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default FilterOptionsReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/FilterOptions/FilterOptionsReduxProps.ts
// module id = 356
// module chunks = 0